import {
  SET_CLIENT,
  LOG_OUT,
} from '../constants';

const initialState = {
  organisations: [],
  organisationsLoaded: false,
};

const extractOrganisations = data => {
  const organisationsSorted = [];
  data.categories.forEach((category, categoryIndex) => {
    category.subcategories.forEach((subcategory, subcategoryIndex) => {
      subcategory.organisations.forEach(organisation => {
        organisationsSorted.push({
          ...organisation,
          label: organisation.name,
          value: organisation.id,
          category: category.name,
          subcategory: subcategory.name,
          categoryIndex,
          subcategoryIndex,
        });
      });
    });
  });
  return organisationsSorted.sort((a, b) => {
    if(a.name < b.name) {
      return -1;
    } else if(a.name > b.name) {
      return 1;
    }
    return 0;
  });
};

const organisations = ( state = initialState, action ) => {
  switch ( action.type ) {
    case LOG_OUT:
      return {
        ...initialState,
      };
      case SET_CLIENT:
      return {
        ...state,
        organisations: extractOrganisations(action.data),
        organisationsLoaded: true,
      };
    default:
      return state;
  }
};

export default organisations;
